const FooterFaqIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
  >
    <circle className="fill-(--footer-icon)" cx="16" cy="16" r="16"></circle>
    <path
      className="fill-(--path-footer-icon)"
      fillRule="evenodd"
      d="M19.54 21.635a.501.501 0 00-.601-.012l-.413.297v-.8h1.31v.748l-.296-.233zM11 11.739c.36.219.794.347 1.26.347h8.012v8.034H11v-8.381zm1.26-2.74h6.761a2.074 2.074 0 00-.23.544h-6.273a.5.5 0 000 1H18.8c.05.195.126.376.226.543H12.26c-.695 0-1.26-.468-1.26-1.043S11.565 9 12.26 9zm8.512 2.087a1.044 1.044 0 01-1.043-1.043c0-.575.468-1.043 1.043-1.043a.499.499 0 100-1H12.26C11.014 8 10 8.916 10 10.043V20.62a.5.5 0 00.5.5h7.024v1.777c0 .187.106.359.273.445.164.083.365.07.52-.04l.9-.647.81.635a.498.498 0 00.527.056.5.5 0 00.281-.45v-1.801a.475.475 0 00.112-.044.496.496 0 00.325-.465v-8.861c0-.025-.01-.046-.013-.07.003-.023.013-.044.013-.07a.5.5 0 00-.5-.5z"
      clipRule="evenodd"
    ></path>
  </svg>
)

export { FooterFaqIcon }
